import React from 'react'
import { Box, Typography, IconButton, SvgIcon } from '@mui/material'
import { Close } from '@mui/icons-material'

interface SidebarHeaderProps {
  title: string
  leftIcon?: React.ReactNode
  onLeftIconClick?: () => void
  onClose: () => void
}

export function SidebarHeader({ title, leftIcon, onLeftIconClick, onClose }: SidebarHeaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '65px',
        px: '24px',
        borderBottom: '1px solid',
        borderColor: 'grey.200',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, minWidth: 0 }}>
        {leftIcon &&
          (onLeftIconClick ? (
            <IconButton
              size="small"
              onClick={onLeftIconClick}
              aria-label="Navigate back"
              data-testid="sidebar-header-left-button"
              sx={{ mr: 0.5, flexShrink: 0 }}
            >
              {leftIcon}
            </IconButton>
          ) : (
            <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>{leftIcon}</Box>
          ))}
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            fontSize: '1rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {title}
        </Typography>
      </Box>
      <IconButton
        onClick={onClose}
        size="small"
        sx={{ color: 'grey.600' }}
        data-testid="sidebar-header-close-button"
        aria-label="Close sidebar"
      >
        <Close />
      </IconButton>
    </Box>
  )
}
